import { useContext } from 'react';
import { StoreContext } from '@roc/feature-app-core';
import { LoanBaseStore } from '../stores/loanBaseStore';

export const useLoanStore = () =>
  useContext<{
    loanStore: LoanBaseStore;
  }>(StoreContext);
